import { render } from "./HygieneView.vue?vue&type=template&id=2dddba12&scoped=true"
import script from "./HygieneView.vue?vue&type=script&lang=js"
export * from "./HygieneView.vue?vue&type=script&lang=js"

import "./HygieneView.vue?vue&type=style&index=0&id=2dddba12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dddba12"]])

export default __exports__